<template>
  <div v-if="users" class="searchbar-found" id="users-list">
    <table class="table table-hover w-100" role="table" aria-label="Liste des utilisateurs">
      <caption class="sr-only">{{$t('administration.users_list_description')}}</caption>
      <thead>
        <tr role="row">
          <th scope="col" class="text-center" id="user-id-header">{{$t('administration.user_id')}}</th>
          <th scope="col" class="text-center" id="user-login-header">{{$t('administration.user_login')}}</th>
          <th scope="col" class="text-center" id="user-name-header">{{$t('administration.user_firstname_name')}}</th>
          <th scope="col" class="text-center sr-only" id="actions-header">{{$t('common.actions')}}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(usersGroup, key) in users">
          <tr role="row" class="group-title" :key="`group-${key}`">
            <th colspan="4" class="font-weight-bold" scope="colgroup">{{ key }}</th>
          </tr>
          <tr v-for="user in usersGroup" :key="user.Id" 
              role="row"
              :class="{ 'boxRequest clickable': canGetUserAccountDetail() }"
              @click="canGetUserAccountDetail() ? seeDetails(user) : seeDetails()"
              :aria-label="canGetUserAccountDetail() ? $t('administration.view_user_details', {name: user.Name}) : undefined">
            <td class="text-center" :headers="'user-id-header'">{{ user.Id }}</td>
            <td class="text-center" :headers="'user-login-header'">{{ user.Login }}</td>
            <td class="text-center" :headers="'user-name-header'">{{ user.Name }}</td>
            <td class="text-center sr-only" :headers="'actions-header'">
              <span v-if="canGetUserAccountDetail()">{{$t('administration.clickable_row')}}</span>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import {loadPage} from '@/helpers/routing'

export default {
  name: 'ListUsers',
  components: {

  },
  props: ['users'],
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {

  },
  beforeDestroy () {

  },
  methods: {
    canGetUserAccountDetail () {
      return (this.$engine.firstOn().user.get().rights.admin_user_detail === '1')
    },
    seeDetails: function (user = null) {
      if (!user) {
        return
      }
      if (!user.Id) {
        return
      }
      loadPage(this, {
        url: '/administration/accountDetail/' + user.IdUserAccount
      })
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.boxRequest:hover {
  background-color: #f5f5f5;
}

.group-title th {
  background-color: #e9ecef;
  padding: 0.75rem;
}

table {
  margin-bottom: 0;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
